import router from "@/router";
import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";

const isUnauthorized = (error) => error.response.status == 401;

const logoutOnUnauthorized = async (error) => {
  let url = error?.response?.config?.url;

  if (url.includes('/extern/projects')) throw error;

  if (url !== WorkAuthentication.LOGOUT_PATH) {
    await WorkAuthentication.logout();
  }

  router.push('/login').catch(() => {});
}

export { isUnauthorized, logoutOnUnauthorized }
